// Generated by scripts/write-love-wins-all-replay-fixtures.ts.
// Do not edit manually.

import type { LoveWinsAllReplayEventType } from "./event-adapter";

export interface LoveWinsAllReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface LoveWinsAllReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: LoveWinsAllReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface LoveWinsAllReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "love-wins-all";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly players: readonly LoveWinsAllReplayFixturePlayer[];
  readonly events: readonly LoveWinsAllReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const LOVE_WINS_ALL_REPLAY_FIXTURES: Record<
  string,
  LoveWinsAllReplayFixture
> = {
  "heuristic-2p": {
    schemaVersion: 1,
    gameType: "love-wins-all",
    scenario: "heuristic-2p",
    source: "generated",
    capturedAt: "2026-06-24T00:00:00.000Z",
    players: [
      {
        id: "p1",
        name: "선 (휴리스틱·압박)",
        role: "host",
      },
      {
        id: "p2",
        name: "후 (휴리스틱·소극)",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "heuristic-2p",
            players: [
              {
                playerId: "p1",
                label: "선",
              },
              {
                playerId: "p2",
                label: "후",
              },
            ],
            phase: "bet",
            round: 0,
            leadPlayerId: "p1",
            currentPlayerId: "p1",
            deck: [
              "rock",
              "love",
              "scissors",
              "love",
              "paper",
              "paper",
              "scissors",
              "scissors",
              "paper",
              "scissors",
              "scissors",
              "paper",
              "scissors",
              "paper",
              "rock",
              "rock",
              "scissors",
              "scissors",
              "scissors",
              "rock",
              "rock",
              "love",
              "scissors",
              "scissors",
            ],
            hands: {
              p1: ["rock", "rock", "paper"],
              p2: ["scissors", "paper", "love"],
            },
            chips: {
              p1: 24,
              p2: 24,
            },
            pot: 2,
            contributed: {
              p1: 1,
              p2: 1,
            },
            raisesUsed: 0,
            lastAggressorId: null,
            rngState: 1575801032,
            lastRound: null,
            winnerId: null,
            lastAction: null,
            moveNumber: 0,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "check",
          moveNumber: 0,
        },
      },
      {
        sequenceNumber: 3,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 1,
        },
      },
      {
        sequenceNumber: 4,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "check",
          moveNumber: 2,
        },
      },
      {
        sequenceNumber: 5,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 3,
        },
      },
      {
        sequenceNumber: 6,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 4,
        },
      },
      {
        sequenceNumber: 7,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "check",
          moveNumber: 5,
        },
      },
      {
        sequenceNumber: 8,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "check",
          moveNumber: 6,
        },
      },
      {
        sequenceNumber: 9,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 7,
        },
      },
      {
        sequenceNumber: 10,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 8,
        },
      },
      {
        sequenceNumber: 11,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 9,
        },
      },
      {
        sequenceNumber: 12,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 10,
        },
      },
      {
        sequenceNumber: 13,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 11,
        },
      },
      {
        sequenceNumber: 14,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 12,
        },
      },
      {
        sequenceNumber: 15,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 13,
        },
      },
      {
        sequenceNumber: 16,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 14,
        },
      },
      {
        sequenceNumber: 17,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 15,
        },
      },
      {
        sequenceNumber: 18,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 16,
        },
      },
      {
        sequenceNumber: 19,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 17,
        },
      },
      {
        sequenceNumber: 20,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 18,
        },
      },
      {
        sequenceNumber: 21,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 19,
        },
      },
      {
        sequenceNumber: 22,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 20,
        },
      },
      {
        sequenceNumber: 23,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 21,
        },
      },
      {
        sequenceNumber: 24,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 22,
        },
      },
      {
        sequenceNumber: 25,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 23,
        },
      },
      {
        sequenceNumber: 26,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 24,
        },
      },
      {
        sequenceNumber: 27,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 25,
        },
      },
      {
        sequenceNumber: 28,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 26,
        },
      },
      {
        sequenceNumber: 29,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 27,
        },
      },
      {
        sequenceNumber: 30,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 28,
        },
      },
      {
        sequenceNumber: 31,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 29,
        },
      },
      {
        sequenceNumber: 32,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 30,
        },
      },
      {
        sequenceNumber: 33,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 31,
        },
      },
      {
        sequenceNumber: 34,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 32,
        },
      },
      {
        sequenceNumber: 35,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 33,
        },
      },
      {
        sequenceNumber: 36,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 34,
        },
      },
      {
        sequenceNumber: 37,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 35,
        },
      },
      {
        sequenceNumber: 38,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 36,
        },
      },
      {
        sequenceNumber: 39,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 37,
        },
      },
      {
        sequenceNumber: 40,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 38,
        },
      },
      {
        sequenceNumber: 41,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 39,
        },
      },
      {
        sequenceNumber: 42,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 40,
        },
      },
      {
        sequenceNumber: 43,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 41,
        },
      },
      {
        sequenceNumber: 44,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 42,
        },
      },
      {
        sequenceNumber: 45,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 43,
        },
      },
      {
        sequenceNumber: 46,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 44,
        },
      },
      {
        sequenceNumber: 47,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 45,
        },
      },
      {
        sequenceNumber: 48,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 46,
        },
      },
      {
        sequenceNumber: 49,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 47,
        },
      },
      {
        sequenceNumber: 50,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 48,
        },
      },
      {
        sequenceNumber: 51,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 49,
        },
      },
      {
        sequenceNumber: 52,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 50,
        },
      },
      {
        sequenceNumber: 53,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 51,
        },
      },
      {
        sequenceNumber: 54,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 52,
        },
      },
      {
        sequenceNumber: 55,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 53,
        },
      },
      {
        sequenceNumber: 56,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 54,
        },
      },
      {
        sequenceNumber: 57,
        eventType: "Bet",
        userId: "p1",
        payload: {
          playerId: "p1",
          move: "bet",
          moveNumber: 55,
        },
      },
      {
        sequenceNumber: 58,
        eventType: "Bet",
        userId: "p2",
        payload: {
          playerId: "p2",
          move: "fold",
          moveNumber: 56,
        },
      },
    ],
    notes: [
      "러브 윈즈 올은 숨김정보 게임 — 손패는 서버 권위. 픽스처 init은 덱·양측 손패 전체(복기용)를 담고, 화면은 상대 손패를 마스킹(뒷면)한다.",
      "공정 휴리스틱(no-oracle): 봇은 마스킹된 뷰만 사용(상대 손패 안 보임). p2=소극(체크·압박 시 폴드), p1=압박(초반 쇼다운으로 족보 공개 → 이후 벳으로 폴드 유도). 승부는 칩 흐름(폴드)으로 결정 → p1이 p2 칩을 0으로.",
      "결과: 57수, 쇼다운 3 + 폴드 25 → 선(p1) 승리 (28라운드).",
    ],
  },
};
